import React, { useEffect, useState } from 'react';
import { Tabs } from 'antd';
import { useParams } from 'react-router-dom';
import { api, endpoints } from '../../api';
import { BlueLayout, PagesContainerUI, TabsContainer } from '../../styles/styled';
import { PovsType } from '../PovsLkPage/types';
import EditPovsComponent from './components/EditPovsComponent';
import PovsInfoPage from './components/PovsInfoPage';

const { TabPane } = Tabs;

export const EditPovsPage = () => {
  const { id } = useParams();
  const [currentPovsState, setCurrentPovs] = useState<PovsType | null>(null);

  async function refreshPovsData() {
    if (id) {
      try {
        const response = await api.get<PovsType>(endpoints.getExpertById(id));

        setCurrentPovs(response.data);
      } catch (err) {}
    }
  }

  useEffect(() => {
    refreshPovsData();
    //eslint-disable-next-line
  }, []);

  return (
    <PagesContainerUI>
      <BlueLayout>{currentPovsState?.povs?.gov_fio}</BlueLayout>
      <TabsContainer white>
        <Tabs type="card" tabBarGutter={0}>
          <TabPane tab="Профиль" key="1">
            <PovsInfoPage povs={currentPovsState} />
          </TabPane>
          <TabPane tab="Редактирование" key="2">
            <EditPovsComponent refresh={refreshPovsData} noAdd currentPovs={currentPovsState} id={id} />
          </TabPane>
        </Tabs>
      </TabsContainer>
    </PagesContainerUI>
  );
};
